"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextarea = void 0;
var _Textarea = require("./Textarea");
// TODO: in v9, move styled() from Textarea.jsx to here
var StyledTextarea = _Textarea.Textarea;
exports.StyledTextarea = StyledTextarea;